import { http } from '@pendo/http';
const guideCategoryApi = '/api/s/_SID_/category/guideCategory';

export function fetchGuideCategories ({ items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`${guideCategoryApi}${params}`);
}

export function fetchGuideCategory ({ categoryId, items }) {
    const params = items ? '?items=true' : '';

    return http.get(`${guideCategoryApi}/${categoryId}${params}`);
}

export async function createGuideCategory (category) {
    return http.post('/api/s/_SID_/category', category);
}

export async function updateGuideCategory (category) {
    return http.put(`/api/s/_SID_/category/${category.id}`, category);
}

export async function deleteGuideCategory (id, type, params = {}) {
    return http.delete(`/api/s/_SID_/category/${type}/${id}`, { params });
}

export async function addGuideToCategory (params) {
    const { categoryId, guideId } = params;

    const response = await http.put(`${guideCategoryApi}/${categoryId}/guide/${guideId}`, null);

    return response;
}

export async function removeGuideFromCategory (params) {
    const { categoryId, guideId } = params;

    const response = await http.delete(`${guideCategoryApi}/${categoryId}/guide/${guideId}`);

    return response;
}
